import { NoteIcon as PhosphorNoteIcon } from "@phosphor-icons/react/dist/ssr/Note";

import { createAppIcon } from "@/components/createAppIcon";

export const NoteIcon = /* @__PURE__ */ createAppIcon(PhosphorNoteIcon);
